<template>
    <modal
        name="visibilidad-reducida-butaca"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="visibilidad-reducida-butaca"
        :adaptive="true"
        :click-to-close="false"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">{{ titulo }}</h2>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <h3 class="text-danger">{{ mensaje }}</h3>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="aceptar()">Aceptar</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>


<script>
    import { esSesionAudicionReducida } from '@/utils/visibilidadReducida';

    export default {
        props: {
            sesion_id: {
                default: null
            }
        },
        computed: {
            sesionIdEfectiva() {
                if (this.sesion_id !== null && this.sesion_id !== undefined) {
                    return this.sesion_id;
                }

                return this.$route?.params?.sesion_id ?? null;
            },
            titulo() {
                return esSesionAudicionReducida(this.sesionIdEfectiva)
                    ? 'Butaca con visibilidad y audición reducida'
                    : 'Butaca con visibilidad reducida';
            },
            mensaje() {
                return esSesionAudicionReducida(this.sesionIdEfectiva)
                    ? 'Esta butaca es de visibilidad y audición reducida, no garantizamos la perfecta visión ni audición del evento.'
                    : 'Esta butaca es de visibilidad reducida, no garantizamos la perfecta visión del evento.';
            }
        },
        methods: {
            aceptar(){
                this.$emit('aceptar');
            },
        },
    }
</script>
